module.exports = __webpack_public_path__ + "img/材料力学6_8_2.c2648bef.jpg";